import CrmServiceModel from "@/models/CrmServiceModel";

export default class CustomerGrowerModel extends CrmServiceModel {
  modelName () {
    return 'customer-growers'
  }
  icon () {
    return 'address-book'
  }
  defaults () {
    return {
      id: null,
      customer_id: null,
      name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations () {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
}